import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {catchError, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';

import {RetrieveServiceRegionSuccessful} from '../actions/lookup.action';
import {LookupDataService} from './lookup.data.service';
import {ProjectServiceRegion} from '../../../common/project.model';

export const ServiceRegionResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  store: Store = inject(Store),
  lookupService: LookupDataService = inject(LookupDataService)
): Observable<ProjectServiceRegion>|Promise<any>|any => {
  return lookupService.RetrieveServiceRegions().pipe(
    catchError(() => {
      return of();
    }),
    tap((serviceRegions: ProjectServiceRegion[]) => store.dispatch(RetrieveServiceRegionSuccessful(serviceRegions)))
  );
};
